/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Duration_LabelInputs */

const en_admin_discounts_duration_label = /** @type {(inputs: Admin_Discounts_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration`)
};

const de_admin_discounts_duration_label = /** @type {(inputs: Admin_Discounts_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer`)
};

const es_admin_discounts_duration_label = /** @type {(inputs: Admin_Discounts_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración`)
};

const fr_admin_discounts_duration_label = /** @type {(inputs: Admin_Discounts_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée`)
};

/** @type {(inputs: Admin_Discounts_Duration_LabelInputs) => LocalizedString} */
const it_admin_discounts_duration_label = en_admin_discounts_duration_label;

/** @type {(inputs: Admin_Discounts_Duration_LabelInputs) => LocalizedString} */
const pt_br2_admin_discounts_duration_label = en_admin_discounts_duration_label;

/** @type {(inputs: Admin_Discounts_Duration_LabelInputs) => LocalizedString} */
const pl_admin_discounts_duration_label = en_admin_discounts_duration_label;

/** @type {(inputs: Admin_Discounts_Duration_LabelInputs) => LocalizedString} */
const hu_admin_discounts_duration_label = en_admin_discounts_duration_label;

/** @type {(inputs: Admin_Discounts_Duration_LabelInputs) => LocalizedString} */
const ro_admin_discounts_duration_label = en_admin_discounts_duration_label;

/**
* | output |
* | --- |
* | "Duration" |
*
* @param {Admin_Discounts_Duration_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_duration_label = /** @type {((inputs?: Admin_Discounts_Duration_LabelInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Duration_LabelInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_duration_label(inputs)
	if (locale === "de") return de_admin_discounts_duration_label(inputs)
	if (locale === "es") return es_admin_discounts_duration_label(inputs)
	if (locale === "fr") return fr_admin_discounts_duration_label(inputs)
	if (locale === "it") return it_admin_discounts_duration_label(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_duration_label(inputs)
	if (locale === "pl") return pl_admin_discounts_duration_label(inputs)
	if (locale === "hu") return hu_admin_discounts_duration_label(inputs)
	return ro_admin_discounts_duration_label(inputs)
});
export { admin_discounts_duration_label as "admin.discounts.duration_label" }